// utils/validation.ts

export const REGEX = {
  name: /^[A-Za-z][A-Za-z'-. ]{1,}$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  phone: /^[6-9]\d{9}$/,
  internationalPhone: /^\+?[1-9]\d{7,14}$/,
  password: /^(?=.*[A-Z])(?=.*\d).{8,30}$/,
  pan: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
  number: /^\d+$/,
  text: /^[A-Za-z\s]+$/,
} as const;

export const validatePhone = (phone: string): boolean =>
  REGEX.phone.test(phone);

export const validateEmail = (email: string): boolean =>
  REGEX.email.test(email);

export const validateName = (name: string): boolean =>
  REGEX.name.test(name.trim());

export const validatePassword = (password: string): boolean =>
  REGEX.password.test(password);

export const validatePAN = (pan: string): boolean => REGEX.pan.test(pan.trim());
